import React, {Component} from 'react';
import {Grid, Row, Col} from 'react-bootstrap';
import ValidatedTextInput from '../../components/common/ValidatedTextInput';

export default class AccountProfile extends Component {

    render() {
        return (
            <Grid fluid>
                <Row>
                    <Col md={2}>
                        Email
                    </Col>
                    <Col md={6}>
                        <ValidatedTextInput label="" placeholder="Email" name="email" disabled={true} />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        Name
                    </Col>
                    <Col md={6}>
                        <ValidatedTextInput label="" placeholder="User name" name="name" />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        Phone
                    </Col>
                    <Col md={6}>
                        <ValidatedTextInput label="" placeholder="Contact phone" name="phone" />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                    </Col>
                    <Col md={6}>
                        {this.props.user.emailVerified ? null : <a onClick={this.props.onEmailVerificationClick}>Resend Verification Email</a>}
                    </Col>
                </Row>
            </Grid>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/account/AccountProfile.jsx